// https://app.growthbook.io/features/prcng-861_v1
export const DECREASE_STANDARD_PRICE_FLAG_NAME = 'prcng-861_v1'
